// @flow

import isEmail from 'validator/lib/isEmail';

export type ValidationErrorType = {
  field: string,
  message: string,
};

export default class Validator {
  rules: Object;

  constructor(rules: Object) {
    this.rules = rules;
  }

  validate(data: Object, rules: Object = this.rules) {
    const errors = [];

    for (const [field, matchers] of Object.entries(rules)) {
      const value = data[field];

      //$FlowFixMe;
      for (const match of matchers) {
        const error = match(value, data);

        if (error) {
          errors.push({
            field,
            message: error,
          });

          break;
        }
      }
    }

    return errors;
  }

  static isRequired = (value: string | number | boolean) => !value && 'This field is required';

  static isValidEmail = (value: string) =>
    !isEmail(value) && 'Please type your email address in the format yourname@examle.com';
}



// WEBPACK FOOTER //
// ./src/utils/validation.js